import React, { useState } from 'react';
// Import Daging
import PahaAyam from '../../../assets/images/daging/ayam/2.PahaAyam.jpeg';
import HatiAyam from '../../../assets/images/daging/ayam/4.HatiAyam.jpeg';
import SayapAyam from '../../../assets/images/daging/ayam/7.SayapAyam.jpeg';
import DagingKambingImg from '../../../assets/images/daging/kambing/DagingKambing.jpeg';
import DagingSapiImg from '../../../assets/images/daging/sapi/1.DagingSapi.jpeg';
import HatiSapi from '../../../assets/images/daging/sapi/1.DagingSapi.jpeg';

import ProductItem from '../../../components/Category/ProductItem';

const Meat = ({
  DagingAyam = [
    {
      nameProduct: 'Ayam Paha',
      imageProduct: PahaAyam,
      weight: '1 kg',
      priceBefore: '3.0000',
      priceAfter: '2.000',
    },
    {
      nameProduct: 'Hati Ayam',
      imageProduct: HatiAyam,
      weight: '1 kg',
      priceBefore: '',
      priceAfter: '5.000',
    },
    {
      nameProduct: 'Sayap Ayam',
      imageProduct: SayapAyam,
      weight: '100 gram',
      priceBefore: '6000',
      priceAfter: '2.000',
    },
  ],
  DagingSapi = [
    {
      nameProduct: 'Daging Sapi',
      imageProduct: DagingSapiImg,
      weight: '1 ikat',
      priceBefore: '3.0000',
      priceAfter: '2.000',
    },
    {
      nameProduct: 'Hati Sapi',
      imageProduct: HatiSapi,
      weight: '1 ikat',
      priceBefore: '',
      priceAfter: '5.000',
    },
  ],
  DagingKambing = [
    {
      nameProduct: 'Daging Kambing',
      imageProduct: DagingKambingImg,
      weight: '1 ikat',
      priceBefore: '3.0000',
      priceAfter: '2.000',
    },
  ],

  CategoryDaging = [
    {
      nameCategory: 'Daging Ayam',
      imgCategory: PahaAyam,
      categoryList: DagingAyam,
    },
    {
      nameCategory: 'Daging Kambing',
      imgCategory: DagingKambingImg,
      categoryList: DagingKambing,
    },
    {
      nameCategory: 'Daging Sapi',
      imgCategory: DagingSapiImg,
      categoryList: DagingSapi,
    },
  ],
}) => {
  const [filterCategory, setFilterCategory] = useState(DagingAyam);
  const [listCategory] = useState(CategoryDaging);
  return (
    <>
      <h1 className="text-font-gray text-3xl font-semibold">Daging</h1>
      <div className="flex py-2 flex-wrap">
        {/* Item Category */}
        {listCategory.map((listCategorys, index) => (
          <div
            className={
              'bg-white rounded-lg shadow-xl mx-2 my-3 px-2 py-1 border  cursor-pointer' +
              (filterCategory === listCategorys.categoryList
                ? ' border-basic-orange '
                : ' border-transparent hover:border-basic-orange')
            }
            onClick={() => {
              setFilterCategory(listCategorys.categoryList);
            }}
            key={index}
          >
            <div className="flex items-start justify-center">
              <p className="flex text-sm w-5/12">
                {listCategorys.nameCategory}
              </p>
              <div className="flex justify-center items-center">
                <img src={listCategorys.imgCategory} className="h-12" alt="" />
              </div>
            </div>
          </div>
        ))}

        {/* End Item Category */}
      </div>

      {/* List Category Item  */}
      <div className="flex flex-wrap w-full -mx-2">
        {/* Start Item */}
        {filterCategory === null ? (
          <div> Error </div>
        ) : (
          <ProductItem productItems={filterCategory} />
        )}
        {/* End Item */}
        {/* End Flash Item */}
      </div>
    </>
  );
};

export default Meat;
